import { Component } from '@angular/core';
import { UserContextService } from 'src/app/core/services/user-context.service';
import { InstanceProviderService } from '../instance-provider.service';

@Component({
  selector: 'app-admin-banner',
  templateUrl: './admin-banner.component.html',
  styleUrls: ['./admin-banner.component.css']
})
export class AdminBannerComponent {

  constructor(private userContextService: UserContextService, private instanceProvider: InstanceProviderService) { }

  async switchBack() {
    const instanceID = this.userContextService.RestorePreviousInstance();

    await this.instanceProvider.TriggerInstanceProviderSetup(instanceID);
  }
}
